var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendMoneyBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171,
    height: 170,
    viewBox: "0 0 171 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0a13d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4645",
    "data-name": "Group 4645",
    transform: "translate(-567 -502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_18_37",
    "data-name": "Component 18 \\u2013 37",
    transform: "translate(567 502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 141,
    height: 140,
    rx: 70,
    transform: "translate(15 15)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 171,
    height: 170,
    rx: 85,
    opacity: 0,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4372",
    "data-name": "Group 4372",
    transform: "translate(-74.88 182.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8864",
    "data-name": "Path 8864",
    d: "M159.968-117.626l2.275-2.277v15.091a9.437,9.437,0,0,0-7.083,9.178,9.507,9.507,0,0,0,9.5,9.5,9.518,9.518,0,0,0,9.495-9.5,9.441,9.441,0,0,0-7.083-9.178v-15.1l2.286,2.287a2.438,2.438,0,0,0,3.414-.007,2.439,2.439,0,0,0,0-3.41l-6.4-6.4a2.439,2.439,0,0,0-3.411,0l-6.4,6.4a2.419,2.419,0,0,0,0,3.414A2.479,2.479,0,0,0,159.968-117.626Zm-.411,21.992a5.1,5.1,0,0,1,5.1-5.1,5.125,5.125,0,0,1,5.1,5.1,5.106,5.106,0,0,1-5.1,5.1A5.1,5.1,0,0,1,159.557-95.634Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8865",
    "data-name": "Path 8865",
    d: "M178.764-115.81h-3.325a2.427,2.427,0,0,0-2.424,2.424,2.428,2.428,0,0,0,2.424,2.425h3.325a8.724,8.724,0,0,1,8.714,8.714v15.219a8.725,8.725,0,0,1-8.714,8.715H150.548a8.725,8.725,0,0,1-8.715-8.715v-15.219a8.724,8.724,0,0,1,8.715-8.714h3.324a2.428,2.428,0,0,0,2.425-2.425,2.427,2.427,0,0,0-2.425-2.424h-3.324a13.574,13.574,0,0,0-12.749,8.973,13.479,13.479,0,0,0-8.364,12.532v15.228A13.575,13.575,0,0,0,143-65.523h28.216a13.548,13.548,0,0,0,12.771-8.994,13.5,13.5,0,0,0,8.341-12.511v-15.219A13.578,13.578,0,0,0,178.764-115.81ZM150.548-73.465h27.324a8.718,8.718,0,0,1-6.658,3.093H143a8.719,8.719,0,0,1-8.715-8.705V-94.305a8.655,8.655,0,0,1,2.7-6.318v13.6A13.579,13.579,0,0,0,150.548-73.465Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_lock",
    "data-name": "vuesax/bold/lock",
    transform: "translate(698.182 533.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_673",
    "data-name": "Ellipse 673",
    transform: "translate(-7.182 -7.182)",
    fill: "#365472",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.712,1.856A1.856,1.856,0,1,1,1.856,0,1.856,1.856,0,0,1,3.712,1.856Z",
    transform: "translate(9.861 13.399)",
    fill: "#ef7a30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M15.368,7.108V5.928C15.368,3.379,14.754,0,9.44,0S3.512,3.379,3.512,5.928v1.18C.868,7.439,0,8.779,0,12.074v1.756c0,3.87,1.18,5.05,5.05,5.05h8.779c3.87,0,5.05-1.18,5.05-5.05V12.074C18.88,8.779,18.011,7.439,15.368,7.108ZM9.44,15.8a2.851,2.851,0,1,1,2.851-2.851A2.854,2.854,0,0,1,9.44,15.8ZM5.05,7.023H4.833v-1.1c0-2.766.784-4.607,4.607-4.607s4.607,1.841,4.607,4.607v1.1h-9Z",
    transform: "translate(2.277 2.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H23.434V23.434H0Z",
    transform: "translate(23.434 23.434) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoneyBasic);
export default __webpack_public_path__ + "static/media/SendMoneyBasic.69e754aa39748b68cf0dd5f7792534ea.svg";
export { ForwardRef as ReactComponent };